import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';

const DataTableAccordion = ({ data, definition }) => {
    if (!data || !data.rows || data.rows.length === 0 || !data.columns) {
        return null;
    }

    const columns = data.columns.map(col => col.name);

    const handleDownload = () => {
        const csvContent = [
            columns.join(','), // Header row
            ...data.rows.map(row => row.join(',')) // Data rows
        ].join('\n');

        // Get chart name and format it for filename
        const chartName = definition?.display_name || 'chart_data';
        const formattedName = chartName.replace(/\s+/g, '-').toLowerCase();

        // Create blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${formattedName}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div style={{ marginTop: '10px', paddingTop: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <Accordion defaultExpanded={false}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                        backgroundColor: 'rgba(0, 0, 0, 0.03)',
                        '& .MuiAccordionSummary-content': {
                            justifyContent: 'center',
                            margin: '4px 0'
                        },
                        minHeight: '32px !important',
                        '&.Mui-expanded': {
                            minHeight: '32px !important',
                            margin: '0 !important'
                        },
                        '& .MuiAccordionSummary-content.Mui-expanded': {
                            margin: '4px 0 !important'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography sx={{ color: 'text.secondary' }}>Chart Data</Typography>
                        <IconButton 
                            size="small" 
                            onClick={(e) => {
                                e.stopPropagation(); 
                                handleDownload();
                            }}
                            sx={{ 
                                color: 'text.secondary',
                                '&:hover': {
                                    color: 'text.primary'
                                }
                            }}
                        >
                            <DownloadIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer 
                        component={Paper} 
                        sx={{ 
                            overflowX: 'auto'
                        }}
                    >
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column, index) => (
                                        <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                                            {column}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.rows.map((row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        {row.map((value, colIndex) => (
                                            <TableCell key={`${rowIndex}-${colIndex}`}>
                                                {value}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default DataTableAccordion; 